import {
  IProjectMilestoneRole,
  IProjectTeamRole,
  ITemplateRolesMapping,
} from "@/interfaces";

export const getLimitedListFromTemplateRoles = (
  teamRole: IProjectTeamRole | IProjectMilestoneRole | undefined,
  templateRolesMap: { [key: string]: ITemplateRolesMapping }
) => {
  if (!teamRole) return null;

  const roleKey = `${teamRole.roleId}-${teamRole.regionId}-${teamRole.functionalAreaId}`;
  const sourceRole = templateRolesMap?.[roleKey];
  const limitedListUsers =
    !sourceRole?.isDeleted && sourceRole?.limitedList
      ? sourceRole?.availableUsers?.map(
          (templateMember) => templateMember.user.id
        )
      : null;

  return limitedListUsers || null;
};
